import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

export interface StatTabTooltip {
  title: string;
  content: string;
}

export interface StatTabData {
  name: string;
  value: string;
  showDelta: boolean;
  deltaValue: number;
  toolTip?: StatTabTooltip;
  subtitle?: string;
}

@Component({
  selector: 'local-seo-stat-tabs',
  templateUrl: './stat-tabs.component.html',
  styleUrls: ['./stat-tabs.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*', minHeight: '0' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: false,
})
export class LocalSEOStatTabsComponent {
  @Input() tabs: StatTabData[];
  @Input() content: TemplateRef<any>[];

  openContent: TemplateRef<any>;
  selectedIndex = -1;

  @ViewChild('tabGroup') tabGroup;

  selectContent(index: number) {
    if (this.selectedIndex === index) {
      this.selectedIndex = -1;
      this.openContent = null;
      return;
    }
    this.selectedIndex = index;
    this.openContent = this.content[index];
  }
}
